import PaymentUserInfo, { PAYMENT_USER_INFO_FIELDS } from './PaymentUserInfo';

export { PaymentUserInfo, PAYMENT_USER_INFO_FIELDS };
export default PaymentUserInfo;
